import { getErrorFromAPI } from '@/helpers/toast';

export const INTEGRATION_GENERIC_ERROR = 'Something went wrong. Please try again in a moment.';

const ROUTING_ERROR_PATTERN = /^Cannot (GET|POST|PUT|PATCH|DELETE)\s/i;

export const getIntegrationErrorMessage = (res: any): string => {
  const status = res?.error?.status;
  if (typeof status === 'string' || (typeof status === 'number' && status >= 500)) {
    return INTEGRATION_GENERIC_ERROR;
  }

  const message = getErrorFromAPI(res);
  if (ROUTING_ERROR_PATTERN.test(message) || message === 'Save failed') {
    return INTEGRATION_GENERIC_ERROR;
  }
  return message;
};
